import React from 'react';
import { Button } from './ui/Button';
const BEEHIIV_URL = 'https://theproductivityblueprint.beehiiv.com';
const ARCHIVE_URL = 'https://theproductivityblueprint.beehiiv.com/archive';
export function Footer() {
  return <footer className="bg-brand-navy text-white pt-16 pb-8" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-113">
          {/* Brand Column */}
          <div data-id="element-114">
            <div className="flex items-center gap-3 mb-6" data-id="element-115">
              <img src="https://cdn.magicpatterns.com/uploads/p2FM8XEfS2zrSHemfzbCaz/The_Productivity_Blueprint_Logo-modified.png" alt="The Productivity Blueprint" className="h-10 w-auto brightness-0 invert" data-id="element-116" />
              <span className="font-serif font-bold text-xl tracking-wide" data-id="element-117">
                The Productivity Blueprint
              </span>
            </div>
            <p className="text-gray-400 mb-8 max-w-sm leading-relaxed" data-id="element-118">
              Decoding the science of productivity to help you master your time,
              attention, and impact. Sent every Sunday.
            </p>
            <div data-id="element-119">
              <h4 className="text-sm font-semibold text-brand-gold uppercase tracking-wider mb-4" data-id="element-120">
                Join the Newsletter
              </h4>
              <Button variant="secondary" onClick={() => window.open(BEEHIIV_URL, '_blank', 'noopener,noreferrer')} data-id="element-121">
                Subscribe
              </Button>
            </div>
          </div>

          {/* Links Column */}
          <div className="flex flex-col justify-center md:items-end" data-id="element-122">
            <h4 className="text-lg font-serif font-semibold mb-6 text-white" data-id="element-123">
              Explore
            </h4>
            <ul className="space-y-4" data-id="element-124">
              <li data-id="element-125">
                <a href={ARCHIVE_URL} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-gold transition-colors" data-id="element-126">
                  Read the Archive
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-127">
          <p className="text-gray-500 text-sm" data-id="element-128">
            © {new Date().getFullYear()} The Productivity Blueprint. All rights
            reserved.
          </p>
          <p className="text-gray-500 text-sm flex items-center gap-1" data-id="element-129">
            Made with ☕ and focus
          </p>
        </div>
      </div>
    </footer>;
}